<template>
  <div id="boxes-by-partner-item">
    <basic-card :class="'movement-card'">
      <div class="img-part col">
        <img
          :src="
            `/static/icons/boxes/${$variables.boxTypes[movement.type]}_box.svg`
          "
        />
      </div>
      <div class="box-code col">
        {{
          $t("boxesByPartnerItem.movementItem.code", {
            code: movement.code
          })
        }}
      </div>
      <div class="box-date col">
        {{
          $t("boxesByPartnerItem.movementItem.date", {
            date: movement.date
          })
        }}
      </div>
      <div class="creator">
        <avatar
          :text="movement.movementCreatorName"
          :size="'30px'"
          :fontSize="'11px'"
        />
      </div>
      <div class="moved">
        <arrow-icon
          class="moving"
          :movingType="movingType"
          v-if="movement.moved !== 0"
        />
        <img class="moving" src="/static/icons/atStore-icon.svg" v-else />
      </div>
    </basic-card>
    <div
      class="with-keyboard col"
      v-if="movement.withKeyBoard === 1 && movement.isMobile == 1"
    >
      <img src="/static/icons/keyboard.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxesByPartnerItem",
  props: {
    movement: {
      type: Object,
      required: true
    }
  },
  components: {},
  data: () => ({}),
  created() {},
  computed: {
    movingType() {
      return this.movement.moved === 1 ? "from" : "to";
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#boxes-by-partner-item {
  margin-bottom: 10px;
  position: relative;
  .movement-card {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: space-between;
    .img-part {
      height: 30px;
      width: 30px;
      img {
        height: 30px;
        width: 30px;
      }
    }
    .box-info {
      display: flex;
    }
    .col {
      font-size: 14px;
      font-weight: 550;
      margin-right: 10px;
      white-space: nowrap;
    }
    .moved {
      .moving {
        height: 30px;
        width: 30px;
      }
    }
    .creator {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0px;
      // margin-left: auto;
    }
  }
}
.with-keyboard {
  height: 30px;
  width: 30px;
  position: absolute;
  top: -10px;
  right: 0px;
  background: aliceblue;
  border-radius: 50%;
  padding: 3px;
  border: 1px solid $color-primary;
  img {
    width: 90%;
  }
}
</style>
